import { checkSchemaError, get, objectToQueryParams } from '@si/utils';
import { useQuery } from '@tanstack/react-query';
import { z } from 'zod';

import { queryKeys } from './queryKeys';
import { useZod } from './useZod';

const responseSchema = z.object({
  userExists: z.boolean(),
  isDistributorUser: z.boolean(),
  onboardingStatus: z.enum(['none', 'pending', 'registered', 'completed', 'cancelled']),
});

interface Params {
  projectId?: string;
  email?: string;
  enabled?: boolean;
}

export function useUserExists({ projectId, email, enabled = true }: Params) {
  const url = `/users/exists${objectToQueryParams({ projectId, email })}`;

  const { zodSchema } = useZod();
  const isValidEmail = checkSchemaError(zodSchema.email, email) === '';

  const { data, error, isLoading } = useQuery({
    queryKey: queryKeys.getUserExists(email, projectId),
    queryFn: () => get({ url, schema: responseSchema }),
    enabled: enabled && isValidEmail,
  });

  return {
    userExists: !!data?.userExists,
    isDistributorUser: !!data?.isDistributorUser,
    onboardingStatus: data?.onboardingStatus ?? 'none',
    error,
    isLoading,
  };
}
